import { mergeFetchedSiteInABoxIntoItems, mergeSiteInABoxItemsById, mergeSiteInABoxSelectedItemById, } from "./merge-item-update";
import { ADD_SITE_IN_A_BOX_ITEM_FAILURE, ADD_SITE_IN_A_BOX_ITEM_REQUEST, ADD_SITE_IN_A_BOX_ITEM_SUCCESS, CLEAR_SITE_IN_A_BOX_ERROR, DELETE_SITE_IN_A_BOX_ITEM_FAILURE, DELETE_SITE_IN_A_BOX_ITEM_REQUEST, DELETE_SITE_IN_A_BOX_ITEM_SUCCESS, EDIT_SITE_IN_A_BOX_ITEM_FAILURE, EDIT_SITE_IN_A_BOX_ITEM_REQUEST, EDIT_SITE_IN_A_BOX_ITEM_SUCCESS, FETCH_SITE_IN_A_BOX_ITEM_FAILURE, FETCH_SITE_IN_A_BOX_ITEM_REQUEST, FETCH_SITE_IN_A_BOX_ITEM_SUCCESS, FETCH_SITE_IN_A_BOX_ITEMS_FAILURE, FETCH_SITE_IN_A_BOX_ITEMS_REQUEST, FETCH_SITE_IN_A_BOX_ITEMS_SUCCESS, GET_SITE_IN_A_BOX_DOC_URL, SEND_EMAIL_FAILURE, SEND_EMAIL_REQUEST, SEND_EMAIL_SUCCESS, SET_SITE_IN_A_BOX_CONNECTIVITY_DEFAULTS, SET_SITE_IN_A_BOX_FILTERS, SET_SITE_IN_A_BOX_PAGINATION, SET_SITE_IN_A_BOX_SITE_DETAILS, } from "./types";
export const initialSiteInABoxState = {
    items: [],
    siteDetails: null,
    connectivityDefaults: null,
    connectivityList: [],
    loading: false,
    dataLoading: false,
    error: null,
    total: 0,
    selectedItem: null,
    selectedItemLoading: false,
    selectedItemError: null,
    addLoading: false,
    addError: null,
    editLoading: false,
    editError: null,
    deleteLoading: false,
    deleteError: null,
    emailLoading: false,
    emailError: null,
    pagination: {
        page: 1,
        per_page: 20,
        total_pages: 0,
        total_count: 0,
    },
    filters: {
        entity: "",
        address: "",
        site_code: "",
        reference_id: "",
        country: "",
        site_type: "",
        org_id: "",
    },
    docUrl: null,
    docUrlLoading: false,
    docUrlError: null,
};
const resolveConnectivityList = (payloadList, currentList) => {
    if (payloadList === undefined) {
        return currentList;
    }
    return payloadList ?? [];
};
const handleFetchSiteInABoxItemSuccess = (state, action) => ({
    ...state,
    selectedItem: action.payload.item,
    items: mergeFetchedSiteInABoxIntoItems(state.items, action.payload.item),
    selectedItemLoading: false,
    selectedItemError: null,
    loading: action.payload.loading,
});
const handleAddSiteInABoxItemSuccess = (state, action) => {
    if (action.payload.item == null) {
        return {
            ...state,
            addLoading: false,
            addError: null,
            loading: action.payload.loading,
        };
    }
    return {
        ...state,
        items: [action.payload.item, ...state.items],
        total: state.total + 1,
        addLoading: false,
        addError: null,
        loading: action.payload.loading,
    };
};
const handleEditSiteInABoxItemSuccess = (state, action) => {
    const updatedItem = action.payload.item;
    if (updatedItem?.id == null) {
        return {
            ...state,
            editLoading: false,
            editError: null,
            loading: action.payload.loading,
        };
    }
    return {
        ...state,
        items: mergeSiteInABoxItemsById(state.items, updatedItem.id, updatedItem),
        selectedItem: mergeSiteInABoxSelectedItemById(state.selectedItem, updatedItem.id, updatedItem),
        editLoading: false,
        editError: null,
        loading: action.payload.loading,
    };
};
const buildEmailSuccessItemPatch = (payload) => {
    const patch = {};
    if (payload.status != null) {
        patch.status = payload.status;
    }
    if (payload.po_number != null) {
        patch.po_number = payload.po_number;
    }
    return Object.keys(patch).length > 0 ? patch : null;
};
const handleSendEmailSuccess = (state, action) => {
    const nextState = {
        ...state,
        emailLoading: false,
        emailError: null,
        loading: action.payload.loading,
    };
    const { id } = action.payload;
    const itemPatch = buildEmailSuccessItemPatch(action.payload);
    if (id == null || itemPatch == null) {
        return nextState;
    }
    return {
        ...nextState,
        items: mergeSiteInABoxItemsById(state.items, id, itemPatch),
        selectedItem: mergeSiteInABoxSelectedItemById(state.selectedItem, id, itemPatch),
    };
};
export function siteInABoxReducer(state = initialSiteInABoxState, action) {
    switch (action.type) {
        case FETCH_SITE_IN_A_BOX_ITEMS_REQUEST:
            return {
                ...state,
                loading: action.payload.loading,
                dataLoading: true,
                error: null,
            };
        case FETCH_SITE_IN_A_BOX_ITEMS_SUCCESS:
            return {
                ...state,
                items: action.payload.items || [],
                total: action.payload.total || 0,
                pagination: { ...state.pagination, ...action.payload.pagination },
                loading: action.payload.loading,
                dataLoading: false,
                error: null,
            };
        case FETCH_SITE_IN_A_BOX_ITEMS_FAILURE:
            return {
                ...state,
                loading: action.payload.loading,
                dataLoading: false,
                error: action.payload.error,
            };
        case SET_SITE_IN_A_BOX_SITE_DETAILS:
            return {
                ...state,
                siteDetails: action.payload.siteDetails,
            };
        case SET_SITE_IN_A_BOX_CONNECTIVITY_DEFAULTS:
            return {
                ...state,
                connectivityDefaults: action.payload.connectivityDefaults,
                connectivityList: resolveConnectivityList(action.payload.connectivityList, state.connectivityList),
            };
        case FETCH_SITE_IN_A_BOX_ITEM_REQUEST:
            return {
                ...state,
                selectedItemLoading: true,
                selectedItemError: null,
                loading: action.payload.loading,
            };
        case FETCH_SITE_IN_A_BOX_ITEM_SUCCESS:
            return handleFetchSiteInABoxItemSuccess(state, action);
        case FETCH_SITE_IN_A_BOX_ITEM_FAILURE:
            return {
                ...state,
                selectedItemLoading: false,
                selectedItemError: action.payload.error,
                loading: action.payload.loading,
            };
        case ADD_SITE_IN_A_BOX_ITEM_REQUEST:
            return {
                ...state,
                addLoading: true,
                addError: null,
                loading: action.payload.loading,
            };
        case ADD_SITE_IN_A_BOX_ITEM_SUCCESS:
            return handleAddSiteInABoxItemSuccess(state, action);
        case ADD_SITE_IN_A_BOX_ITEM_FAILURE:
            return {
                ...state,
                addLoading: false,
                addError: action.payload.error,
                loading: action.payload.loading,
            };
        case EDIT_SITE_IN_A_BOX_ITEM_REQUEST:
            return {
                ...state,
                editLoading: true,
                editError: null,
                loading: action.payload.loading,
            };
        case EDIT_SITE_IN_A_BOX_ITEM_SUCCESS:
            return handleEditSiteInABoxItemSuccess(state, action);
        case EDIT_SITE_IN_A_BOX_ITEM_FAILURE:
            return {
                ...state,
                editLoading: false,
                editError: action.payload.error,
                loading: action.payload.loading,
            };
        case DELETE_SITE_IN_A_BOX_ITEM_REQUEST:
            return {
                ...state,
                deleteLoading: true,
                deleteError: null,
                loading: action.payload.loading,
            };
        case DELETE_SITE_IN_A_BOX_ITEM_SUCCESS:
            return {
                ...state,
                items: state.items.filter((item) => item?.id !== action.payload.id),
                total: Math.max(0, state.total - 1),
                deleteLoading: false,
                deleteError: null,
                loading: action.payload.loading,
            };
        case DELETE_SITE_IN_A_BOX_ITEM_FAILURE:
            return {
                ...state,
                deleteLoading: false,
                deleteError: action.payload.error,
                loading: action.payload.loading,
            };
        case SEND_EMAIL_REQUEST:
            return {
                ...state,
                emailLoading: true,
                emailError: null,
                loading: action.payload.loading,
            };
        case SEND_EMAIL_SUCCESS:
            return handleSendEmailSuccess(state, action);
        case SEND_EMAIL_FAILURE:
            return {
                ...state,
                emailLoading: false,
                emailError: action.payload.error,
                loading: action.payload.loading,
            };
        case SET_SITE_IN_A_BOX_PAGINATION:
            return {
                ...state,
                pagination: { ...state.pagination, ...action.payload },
            };
        case SET_SITE_IN_A_BOX_FILTERS:
            return {
                ...state,
                filters: { ...state.filters, ...action.payload },
            };
        case CLEAR_SITE_IN_A_BOX_ERROR:
            return {
                ...state,
                error: null,
                addError: null,
                editError: null,
                deleteError: null,
                emailError: null,
                selectedItemError: null,
            };
        case GET_SITE_IN_A_BOX_DOC_URL:
            return {
                ...state,
                docUrl: action.payload.docUrl,
                docUrlLoading: action.payload.loading,
                loading: action.payload.loading,
            };
        default:
            return state;
    }
}
export function createSiteInABoxReducer() {
    return siteInABoxReducer;
}
